import React, { useState } from "react";
import styles from "./tabsSection.module.scss";
import clsx from "clsx";
import { RichText } from "prismic-reactjs";
import Dropdown from "@components/TabsSection/Dropdown/dropdown";
import htmlSerializer from "@utils/htmlSerializer/htmlSerializer";
import LocalizedLink from "@components/LocalizedLink/localizedLink";

const TabsSection = ({ tabs, defaultTab, locale, pageSlug, hasTitle = true }) => {
  const [activeTab] = useState(tabs ? tabs[defaultTab] : null);

  if (tabs === null || !Object.keys(tabs).length) {
    return null;
  }

  return (
    <div className={styles.tabsSection}>
      <nav className={styles.tabsSection__tabsDesktop}>
        {Object.keys(tabs).map(key => (
          <LocalizedLink
            to={`/${pageSlug}/${key}`}
            locale={locale}
            className={clsx(
              styles.tabsSection__tab,
              activeTab.title === tabs[key].title && styles.tabsSection__tabSelected
            )}
            key={key}
          >
            {tabs[key].title}
          </LocalizedLink>
        ))}
      </nav>
      <nav className={styles.tabsSection__tabsMobile}>
        <Dropdown
          defaultValue={activeTab}
          values={tabs}
          locale={locale}
          pageSlug={pageSlug}
        />
      </nav>
      <section className={styles.tabsSection__panel}>
        {hasTitle && <h1>{activeTab.title}</h1>}
        {activeTab.text && (
          <RichText render={activeTab.text} htmlSerializer={htmlSerializer} />
        )}
        {activeTab.components &&
          activeTab.components.map((component, index) =>
            React.createElement(component, { key: index })
          )}
      </section>
    </div>
  );
};

export default TabsSection;
